import { render, staticRenderFns } from "./MessageTitle.vue?vue&type=template&id=738c0d20"
import script from "./MessageTitle.vue?vue&type=script&lang=js"
export * from "./MessageTitle.vue?vue&type=script&lang=js"
import style0 from "./MessageTitle.vue?vue&type=style&index=0&id=738c0d20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports